import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "school-comp-table-head",
  templateUrl: "./school-comp-table-head.component.html",
  styleUrls: ["./school-comp-table-head.component.scss"],
})
export class SchoolCompTableHeadComponent implements OnInit {
  @Input() panels;
  @Input() columns;
  @Input() districtOverall;
  @Input() districtColors;
  @Input() district;
  @Input() sortCol;
  @Input() sortDirection;

  @Output() sortColumnClicked = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  sortColumn(column, direction) {
    this.sortColumnClicked.emit({ column: column, direction: direction });
  }

  isMegaLargeNumber(district, columnId) {
    return district &&
      columnId &&
      district[columnId] &&
      district[columnId]["overall"]
      ? parseFloat(district[columnId]["overall"]) > 1000000
      : false;
  }
}
